import CallError from '../../../utils/CallError';
import { getBadParams, getMissingKeys } from '../../../utils/general';
import { envSetup } from '../setup';

/**
 * Gets available env list per envId
 * @param {object} params - an object of params
 * @param {string} params.accessToken - the access token required to get make the request
 */
export default async (params, signal = null) => {
  const requiredParams = ['accessToken', 'appVersion', 'appId', 'orgId', 'envId', 'appType'];
  const paramsRules = {
    accessToken: { allowedTypes: ['string'] },
    appVersion: { allowedTypes: ['string'] },
    appId: { allowedTypes: ['string'] },
    orgId: { allowedTypes: ['string'] },
    envId: { allowedTypes: ['string'] },
    appType: { allowedTypes: ['string'] },
  };
  const missingParams = getMissingKeys(params, requiredParams);
  let badParams = [];
  if (Object.keys(params).length) {
    badParams = getBadParams(params, paramsRules);
  }
  if (missingParams.length || badParams.length) {
    throw new CallError('params', null, 404, { missingParams, badParams });
  }
  const response = await fetch(`${envSetup.endpoint}/v1/environments/${params.envId}/jsonschema`, {
    signal,
    headers: {
      Authorization: `Bearer ${params.accessToken}`,
      'x-app-version-id': params.appVersion,
      'x-ims-org-id': params.orgId,
      'x-api-key': envSetup.apiKey,
      'x-app-id': params.appId,
      'x-app-type': params.appType,
    },
  });
  let jsonConfig = await response.text();

  try {
    jsonConfig = JSON.parse(jsonConfig);
  } catch (e) {
    // response is not json
  }

  if (!response.ok) {
    throw new CallError('http', jsonConfig, response.status, { message: response.statusText });
  } else {
    return jsonConfig;
  }
};
